import { PROMOTION_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const promotionRoute = (): RouteRecordRaw => {
    return {
        path: '/manage/promotion',
        name: PROMOTION_ROUTE_NAME.PROMOTION,
        component: () => import('@/pages/manage/promotion/index.vue'),
    }
};

export const promotionDetailRoute = (): RouteRecordRaw => {
    return {
        path: '/manage/promotion/:id',
        name: PROMOTION_ROUTE_NAME.PROMOTION_DETAIL,
        component: () => import('@/pages/manage/promotion/detail-promotion.vue'),
    }
};

export const promotionAddProductRoute = (): RouteRecordRaw => {
    return {
        path: '/manage/promotion/add-promotion',
        name: PROMOTION_ROUTE_NAME.ADD_PROMOTION,
        component: () => import('@/pages/manage/promotion/add-promotion.vue'),
    }
};

export const promotionEditRoute = (): RouteRecordRaw => {
    return {
        path: '/manage/promotion/edit-promotion/:id',
        name: PROMOTION_ROUTE_NAME.EDIT_PROMOTION,
        component: () => import('@/pages/manage/promotion/edit-promotion.vue'),
    }
};
